import { render } from "./TableCell.vue?vue&type=template&id=07aff271"
import script from "./TableCell.vue?vue&type=script&lang=js"
export * from "./TableCell.vue?vue&type=script&lang=js"
script.render = render

export default script